module.exports = __webpack_public_path__ + "static/media/no_2.1a41ac64.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeFavourableRoll/images/no_2.png
// module id = 378
// module chunks = 0